export default {"src":"/_next/static/media/0xe176ebe47d621b984a73036b9da5d834411ef734.cf54c71c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};